//
//
//
//
//
//
//
//

export default {
  name: 'rb-popular-search',
  inject: ['search'],
  props: {
    category: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      this.search(this.searchTerm)
    },
  },
}
